import type { CMFormSection } from '@/screens/ContentModuleFormScreen/ContentModuleFormScreen'

import type { FormType } from '../types/aiFieldGeneration'

// Helper to get ID parameters based on type
export function getIdParams(type: FormType, props: CMFormSection) {
  switch (type) {
    case 'cm':
      return { task_id: props.taskId! }
    case 'step':
      return { step_id: props.stepId! }
    case 'resource':
      return { resource_id: props.resourceId! }
  }
}

// Helper to get the appropriate form based on type
export function getForm(props: CMFormSection, type: FormType) {
  switch (type) {
    case 'cm':
      return props.moduleForm
    case 'step':
      return props.stepForm
    case 'resource':
      return props.resourceForm
    default:
      return undefined
  }
}

// Centralized error logging
export function logAIGenerationError(context: string, error: unknown, fieldName?: string) {
  console.error(`[AI Generation Error] ${context}:`, {
    fieldName,
    error: error instanceof Error ? error.message : String(error),
    timestamp: new Date().toISOString(),
  })
}
